import React, {Component, PropTypes} from 'react'

export class SelectFilter extends Component{
    constructor(props){
        super(props)
        this.state = {
            defaultMonth: this.props.defaultMonth,
            defaultStatus: this.props.defaultStatus
        }
        this.onSelectMonthChange = (evt) => {
            let newValue = evt.target.value
            this.setState({
                defaultMonth: newValue
            }, ()=>{
                this.search()
            })
        }
        this.onSelectStatusChange = (evt) => {
            let newValue = evt.target.value
            this.setState({
                defaultStatus: newValue
            }, ()=>{
                this.search()
            })
        }
        this.search = () => {
            let month = this.state.defaultMonth
            let statusDays = this.state.defaultStatus
            this.props.searchingData(month, statusDays)
        }
    }
    render(){
        const {months, optionsStatus} = this.props
        return(
            <div>
                <SelectGeneric
                    defaultValue = {this.state.defaultMonth}
                    options = {months}
                    action = {this.onSelectMonthChange}
                    title = "Meses"
                />
                <SelectGeneric
                    defaultValue = {this.state.defaultStatus}
                    options = {optionsStatus}
                    action = {this.onSelectStatusChange}
                    title = "Estado"
                />    
            </div>
            
        )
    }
}
SelectFilter.proptypes = {
    months: PropTypes.object.isRequired,
    optionsStatus: PropTypes.object.isRequired
}
const SelectGeneric = ({defaultValue, options, action, title}) => {
    return(
        <div className="col-sm-12 form-group ">
            <label className="control-label">{title}</label>
            <select className="form-control"
                    value={defaultValue}
                    onChange={action}
            >
                {options.map((option, index)=>{
                    return <option key={index} value={option.value}>{`${option.text}`}</option>
                })}
            </select>
        </div>
    )
}


// WEBPACK FOOTER //
// ./frontEnd/admin/CalendarMaintainer/components/Filters.jsx